import { IS_DEVICE, IS_BROWSER } from '@src/utils/constants';

const iOSSafari = IS_DEVICE.iOS && IS_BROWSER.safari;
const androidChrome = IS_DEVICE.android && IS_BROWSER.chrome;

export const eligibleToAddToHomescreen =
  (androidChrome || iOSSafari) && !window.navigator.standalone;
